export default "__VITE_PUBLIC_ASSET__7deb71f6__"